import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { TripDetailsDialog } from "./trip-details-dialog";

interface ViewTripButtonProps {
  tripId: string;
  variant?: "outline" | "secondary" | "default" | "ghost";
  size?: "sm" | "default" | "lg" | "icon";
}

export function ViewTripButton({
  tripId,
  variant = "outline",
  size = "default",
}: ViewTripButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={(e) => {
          // Prevent event bubbling when used within accordion triggers
          if (e) e.stopPropagation();
          setDialogOpen(true);
        }}
        className={size === "icon" ? "h-8 w-8 p-0" : "gap-1"}
      >
        {size === "icon" ? (
          <ExternalLink className="h-4 w-4" />
        ) : (
          <>
            <ExternalLink className="h-4 w-4" />
            View Details
          </>
        )}
      </Button>

      <TripDetailsDialog
        tripId={dialogOpen ? tripId : null}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  );
}
